import * as Sentry from '@sentry/react';
import { Replay } from '@sentry/replay';
import { browserTracingIntegration } from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { ErrorBoundary } from '@sentry/react';

// ✅ Only initialize in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://1bb170c9709615ef887d7db2279c389f@o4510025251028992.ingest.de.sentry.io/4510025280847952',

    integrations: [
      browserTracingIntegration(), // ✅ correct for v8
      new Replay(),
    ],

    // ✅ Sampling rates
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // ✅ Make tracing work well with HashRouter
    tracePropagationTargets: ['localhost', /^https:\/\/mortis-web\.github\.io/],
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HashRouter>
      <ErrorBoundary fallback={<div>⚠️ Something went wrong</div>}>
        <App />
      </ErrorBoundary>
    </HashRouter>
  </StrictMode>
);
